import { FooterContainer } from "../styleComponents/FooterStyle";

const Footer = () => {
    return (<>
        <FooterContainer>
            <div className="name">
                <h3>Copyright © Renessans ta'lim universiteti</h3>
                <br />
            </div>
        </FooterContainer>
    </>)
}
export default Footer; 